// extracted by mini-css-extract-plugin
export var chip = "_dp-0";
export var filterDropdown = "_dp-5";
export var filterItem = "_dp-6";
export var icon = "_dp-1";
export var removeButton = "_dp-3";
export var removeIcon = "_dp-4";
export var separator = "_dp-2";